import clsx from 'clsx';
import React from 'react';

interface Props {
  className?: string;
  children: React.ReactNode;
  onClick?: React.MouseEventHandler;
  type?: 'button' | 'submit' | 'reset';
  disabled?: boolean;
  color?: 'black' | 'red' | 'blue';
}

function LinkButton({
  className,
  children,
  onClick,
  type = 'button',
  disabled,
  color = 'black',
}: Props): JSX.Element {
  const colorClass = (() => {
    switch (color) {
      case 'blue':
        return 'text-blue-600 hover:text-blue-400';
      case 'black':
        return 'text-gray-900 hover:text-gray-700 disabled:text-black/20';
      case 'red':
        return 'text-red-600 hover:text-red-400';
      default:
        throw new Error(`Unknown color ${color as string}`);
    }
  })();

  return (
    <button
      className={clsx('text-sm font-semibold', colorClass, className)}
      // a type is being provided but eslint doesn't know
      // eslint-disable-next-line react/button-has-type
      type={type}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </button>
  );
}

export default LinkButton;
